<div class="modal-header">
    <h4 class="modal-title"> {{data.isReferenceDevice ? 'Referans' : 'Müşteri'}} Cihazı Güncelle</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body col-12">
    <form [formGroup]="deviceForm">
        <div class="row" *ngIf="!data.isReferenceDevice">
            <!-- Firma Seçimi -->
            <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                <label for="companyId">Firma</label>
                <ng-select [items]="companies" bindLabel="companyName" bindValue="id"
                    formControlName="companyId"></ng-select>
                <div *ngIf="deviceForm.get('companyId')?.invalid && deviceForm.get('companyId')?.touched"
                    class="text-danger">
                    Firma zorunludur.
                </div>
            </div>
        </div>

        <!-- Ürünler -->
        <div class="row">

            <div class="col-xl-12 col-md-6 col-sm-12 col-12">
                <label for="deviceName">Cihaz Adı</label>
                <input type="text" class="form-control" formControlName="deviceName" maxlength="200" />
            </div>

            <!-- Cihaz Türü -->
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="kindId">Cihaz Türü</label>
                <ng-select [items]="kinds" bindLabel="typeName" bindValue="id" formControlName="kindId"></ng-select>
            </div>

            <!-- Marka & Model -->
            <div class="col-xl-3 col-md-5 col-sm-11 col-12">
                <label for="brandModelId">Marka</label>
                <div class="form-group">
                    <ng-select [items]="brands" bindLabel="brandName" bindValue="id" placeholder="Marka seçin"
                        formControlName="brandId" (change)="onBrandChange($event.id)">
                    </ng-select>
                    <div *ngIf="deviceForm.get('brandModelId')?.invalid && deviceForm.get('brandModelId')?.touched"
                        class="text-danger">
                        Marka seçmek zorunludur.
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-md-5 col-sm-11 col-12">
                <label for="brandModelId">Model</label>
                <div class="form-group">
                    <ng-select [items]="filteredModels" bindLabel="modelName" bindValue="id" placeholder="Model seçin"
                        formControlName="brandModelId" [disabled]="!filteredModels.length">
                    </ng-select>
                    <div *ngIf="deviceForm.get('brandModelId')?.invalid && deviceForm.get('brandModelId')?.touched"
                        class="text-danger">
                        Marka seçmek zorunludur.
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="seriNo">Seri No</label>
                <input type="text" class="form-control" formControlName="seriNo" maxlength="30" />
            </div>
        </div>

        <!-- Additional Information -->
        <div class="row">
            <!-- Çözünürlük -->
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="resolution">Çözünürlük</label>
                <input type="text" class="form-control" formControlName="resolution" />
            </div>

            <!-- Periyot -->
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="period">Periyot(Ay)</label>
                <input type="number" class="form-control" formControlName="period" />
            </div>

            <!-- Envanter No -->
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="inventoryNumber">Envanter No</label>
                <input type="text" class="form-control" formControlName="inventoryNumber" />
            </div>

            <!-- Yer -->
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="place">Yer</label>
                <input type="text" class="form-control" formControlName="place" />
            </div>

            <!-- Cihaz Durumu (Aktif/Pasif) -->
            <div class="col-xl-2 col-md-6 col-sm-12 col-12" *ngIf="false">
                <label for="isDeviceStatus">Cihaz Durumu</label>
                <select formControlName="isDeviceStatus" class="form-control" id="isDeviceStatus">
                    <option [value]="true">Aktif</option>
                    <option [value]="false">Pasif</option>
                </select>
            </div>

            <!-- Açıklama -->
            <div class="col-xl-8 col-md-12 col-sm-12 col-12">
                <label for="basicTextarea">Açıklama</label>
                <fieldset class="form-group">
                    <textarea class="form-control" id="basicTextarea" rows="1" placeholder="Cihaz açıklaması"
                        formControlName="description"></textarea>
                </fieldset>
            </div>

            <!-- Referans ID -->
            <div class="col-xl-4 col-md-6 col-sm-12 col-12">
                <label for="referenceId">Referans</label>
                <ng-select [bindValue]="'id'" formControlName="referenceId">
                    <ng-template ng-header-tmp>
                        <button
                            class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                            (click)="showCreateReferenceDialog(); select.blur(); select.close()">
                            <i data-feather="plus"></i>
                            <span class="align-middle ml-25">Referans Ekle</span>
                        </button>
                    </ng-template>
                    <ng-option *ngFor="let reference of references" [value]="reference.id">
                        {{reference.min + reference.unitTypeName + '-' + reference.max +reference.unitTypeName
                        }}</ng-option>
                </ng-select>
            </div>
        </div>
    </form>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success" [disabled]="!deviceForm.valid" (click)="onSumbit()"
        *ngIf="authService.isEndpointStatus('PUT.Updateing.UpdateDevice')">Kaydet</button>
</div>